import { millisecondsInSecond } from 'date-fns';

import { contextStorage } from 'components/widgets/Player/storages';
import networkService from 'services/networkService';

import { restorePlayerAfterError } from '../restorePlayerAfterError/restorePlayerAfterError';

export async function tryToRestorePlayback() {
  const isConnection = await networkService.isNetworkConnection();

  if (isConnection) {
    await restorePlayerAfterError();
  } else {
    const {
      errorContext: { stopLoadingError },
    } = contextStorage.getContext();

    setTimeout(() => stopLoadingError(), millisecondsInSecond);
  }
}
